const HasReminderMixin = (target) => (
  class extends target {
    get reminders() {
      return this.project.reminderStore.query((reminder) => reminder.resourceId === this.id, true);
    }
  }
)

export default HasReminderMixin;